import React from 'react';
import PropTypes from 'prop-types';
import { compose, setDisplayName, setPropTypes } from 'recompose';
import { connect } from 'react-redux';
import classNames from 'classnames';
import Header from './Header';
import Checklist from '../Package/Checklist';
import Details from './Details';
import {
  getCurrentServicePeriod,
  getCurrentServicePrice,
  getCurrentServiceTitle,
  getCurrentServiceFeatures,
  getCurrentServicePayment,
} from '../../../../selectors';
import styles from './CurrentPackage.scss';

function CurrentPackage({
  service,
  vip,
  serviceTitle,
  servicePeriod,
  servicePrice,
  serviceFeatures,
  servicePayment,
}) {
  return (
    <div className={classNames(styles.root)}>
      <Header service={service} title={`${serviceTitle}${vip ? ' VIP' : ''}`} />
      <div className={styles.services}>
        <Checklist features={serviceFeatures} size="large" />
        <Details
          payment={vip ? '' : servicePayment}
          price={vip ? '' : servicePrice}
          period={vip ? '' : servicePeriod}
        />
      </div>
    </div>
  );
}

const mapStateToProps = (state, props) => ({
  serviceTitle: getCurrentServiceTitle(state, props),
  servicePeriod: getCurrentServicePeriod(state, props),
  servicePrice: getCurrentServicePrice(state, props),
  serviceFeatures: getCurrentServiceFeatures(state, props),
  servicePayment: getCurrentServicePayment(state, props),
});

export default compose(
  setDisplayName('CurrentPackage'),
  connect(mapStateToProps),
  setPropTypes({
    expired: PropTypes.bool.isRequired,
    vip: PropTypes.bool.isRequired,
  }),
)(CurrentPackage);
